"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var use_modal_toggle_state_hook_1 = __importDefault(require("../../hooks/use-modal-toggle-state.hook"));

var add_button_component_1 = __importDefault(require("../../common-components/add-button/add-button.component"));

var action_list_menu_component_1 = __importDefault(require("../action-list-menu/action-list-menu.component"));

var select_url_variable_modal_component_1 = __importDefault(require("../select-url-variable-modal/select-url-variable-modal.component"));

var insert_scenario_template_modal_component_1 = __importDefault(require("../insert-scenario-template-modal/insert-scenario-template-modal.component"));

var add_text_scenario_node_modal_component_1 = __importDefault(require("../add-text-scenario-node-modal/add-text-scenario-node-modal.component"));

var AddActionButton = function AddActionButton(_ref) {
  var createTextNode = _ref.createTextNode,
      createImageNode = _ref.createImageNode,
      createImageExplanationNode = _ref.createImageExplanationNode,
      insertTemplate = _ref.insertTemplate,
      setActionUrl = _ref.setActionUrl;

  var _react_1$useState = react_1.useState(null),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      anchorEl = _react_1$useState2[0],
      setAnchorEl = _react_1$useState2[1];

  var _use_modal_toggle_sta = use_modal_toggle_state_hook_1.default(false),
      openAddTextNodeModal = _use_modal_toggle_sta.handleOpen,
      addTextNodeModalProps = _use_modal_toggle_sta.modalProps;

  var _use_modal_toggle_sta2 = use_modal_toggle_state_hook_1.default(),
      openInsertTemplateModal = _use_modal_toggle_sta2.handleOpen,
      insertScenarioTemplateModalProps = _use_modal_toggle_sta2.modalProps;

  var _use_modal_toggle_sta3 = use_modal_toggle_state_hook_1.default(),
      openSelectActionUrleModal = _use_modal_toggle_sta3.handleOpen,
      selectActionUrlModalProps = _use_modal_toggle_sta3.modalProps;

  return react_1.default.createElement("div", null, react_1.default.createElement(add_button_component_1.default, {
    onClick: function onClick(e) {
      return setAnchorEl(e.currentTarget);
    }
  }, "\u30A2\u30AF\u30B7\u30E7\u30F3\u8FFD\u52A0"), react_1.default.createElement(action_list_menu_component_1.default, {
    anchorEl: anchorEl,
    handleClose: function handleClose() {
      return setAnchorEl(null);
    },
    handleSelectText: openAddTextNodeModal,
    handleSelectImage: createImageNode,
    handleSelectImageExplanation: createImageExplanationNode,
    handleSelectUrl: openSelectActionUrleModal,
    handleSelectTemplate: openInsertTemplateModal
  }), react_1.default.createElement(add_text_scenario_node_modal_component_1.default, {
    modalProps: addTextNodeModalProps,
    handleSave: createTextNode
  }), react_1.default.createElement(insert_scenario_template_modal_component_1.default, Object.assign({}, insertScenarioTemplateModalProps, {
    handleInsertScenarioTemplate: insertTemplate
  })), react_1.default.createElement(select_url_variable_modal_component_1.default, Object.assign({}, selectActionUrlModalProps, {
    onUrlVariableSelect: function onUrlVariableSelect(variable) {
      return setActionUrl("${".concat(variable.key, "}"));
    }
  })));
};

exports.default = AddActionButton;